import Markdown from "react-markdown"
import styled from "styled-components"

import { Text } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"
import { ExpandableSection } from "src/ui/ExpandableSection/ExpandableSection"
import { spacing } from "src/ui/spacing"

export function ExpandableContextGuidelines() {
  const { tPlaceholder } = useTranslate()

  return (
    <ExpandableSection
      title={
        <Text variant="subtitleS" color="secondary">
          {tPlaceholder("Content Guidelines")}
        </Text>
      }
      variant="card"
      summaryProps={{
        cardPaddingOverride: spacing.M,
      }}
    >
      <GuideLinesWrapper>
        <div>
          <Text variant="subtitleS" color="secondary">
            {tPlaceholder("What to include")}
          </Text>
          <Text variant="bodyS" color="secondary">
            <StyledMarkdown>
              <Markdown>
                {tPlaceholder(
                  "- Frequently asked questions\n- Stays policies and guidelines\n- Information of local activities"
                )}
              </Markdown>
            </StyledMarkdown>
          </Text>
        </div>

        <div>
          <Text variant="subtitleS" color="secondary">
            {tPlaceholder("Best practices")}
          </Text>
          <Text variant="bodyS" color="secondary">
            <StyledMarkdown>
              <Markdown>
                {tPlaceholder(
                  "- Use descriptive titles\n- Break up long information to multiple contents\n- Include relevant keywords\n- Keep information up to date"
                )}
              </Markdown>
            </StyledMarkdown>
          </Text>
        </div>
      </GuideLinesWrapper>
    </ExpandableSection>
  )
}

const GuideLinesWrapper = styled.div`
  display: flex;
  gap: ${spacing.M};
  flex-wrap: wrap;
  padding: 0 ${spacing.M} ${spacing.M};

  & > * {
    flex: 1;
    min-width: 200px;
  }
`

const StyledMarkdown = styled.div`
  ul {
    list-style-type: disc;
    padding-left: ${spacing.M};
  }

  p:first-child,
  p:last-child {
    margin: 0;
  }

  ul:first-child,
  ul:last-child {
    margin: 0;
  }
`
